<template>
  <div class="order-preview">
    <!--<van-nav-bar class="" title="确认下单" left-arrow @click-left="onClickLeft" />-->

    <div class="shop-list">
      <shop-list />
    </div>
    <!--<div class="shop-header">
      <div class="shop-img">
        <img class="img" :src="goodsData.shopAvatar" alt="">
      </div>
      <div class="shop-name">{{ goodsData.shopName }}</div>
    </div>-->

    <div class="goods-con">
      <div class="goods">
        <div class="img-con">
          <img class="img" :src="goodsData.coverPath + '?imageView2/0/w/140/h/100'" alt="">
        </div>
        <div class="title-con">
          <div class="title"><span class="type">{{ knowledgeTypeName(goodsData.courseType) }}</span>{{ goodsData.title }}</div>
          <div class="sub-text">
            <div class="num-con" v-if="goodsData.courseType===null || goodsData.courseType==='VIDEO' || goodsData.courseType==='AUDIO'">
              <span class="num" v-if="goodsData.courseType===null">共{{ goodsData.planCourseCount }}期 <span v-if="goodsData.currentCourseCount">，已更新至{{ goodsData.currentCourseCount }}期</span></span>
              <span class="num" v-if="goodsData.courseType!==null">时长:{{ formatSeconds(goodsData.courseType ,goodsData.duration) }}</span>
            </div>
            <div v-if="goodsData.courseType!==null && goodsData.courseType!=='VIDEO' && goodsData.courseType!=='AUDIO'">
              <span class="num" style="color: #f74d4d;">开播时间:{{ goodsData.startTime }}</span>
            </div>
            <span class="num">收藏:{{ goodsData.collectUserCount }}</span>
            <span class="num">已售:{{ goodsData.salesVolume }}</span>
          </div>
        </div>
      </div>
    </div>


    <div class="buy-icon-con">
      <span class="icon"></span>
      <span>购买{{ knowledgeTypeName(goodsData.courseType) }}</span>
    </div>

    <!--<div class="pay-btn" v-if="!goodsData.purchaseGoods">



    </div>-->


    <div class="pay-btn">
      <div class="btn-con" v-if="!goodsData.purchaseGoods && previewOrderData.shelvesStatus==='ON_SHELF' && previewOrderData.shopOpenStatus==='OPEN' && previewOrderData.shelfStocks!==0">
        <div class="total">合计: ￥{{ previewOrderData.actualAmount | filter2 }}</div>
        <div class="btn" @click="buyOrder">立即支付</div>
      </div>

      <div class="btn-con" v-if="!goodsData.purchaseGoods && previewOrderData.shelfStocks===0">
        <div class="btn gray-btn">缺货</div>
      </div>

      <div class="btn-con" v-if="!goodsData.purchaseGoods && previewOrderData.shelvesStatus!=='ON_SHELF'">
        <div class="btn gray-btn">商品已下架</div>
      </div>

      <div class="btn-con" v-if="!goodsData.purchaseGoods && previewOrderData.shopOpenStatus!=='OPEN'">
        <div class="btn gray-btn">店铺未营业</div>
      </div>


      <div class="btn-con" v-if="goodsData.purchaseGoods">
        <div class="btn gray-btn">已购买</div>
      </div>
    </div>

    <ant-pay ref="antpay" :show="show" :showPayType="true" :paynum="paynum" :payData="payData" @close="onPayClose" @onPay="onPay" />
  </div>

</template>

<script>
import { columnDetail, courseDetail, directDetail } from '@/api/mall/mallGoods'
import { introduce } from '@/api/mall/mallShop'
import { previewOrder, placeOrder } from '@/api/mall/mallOrder'
import { getPaySignInfo } from '@/api/pay/payApi'
import AntPay from '@/components/antpay/antpay'
import shopList from './components/ShopList'
// import goodsList  from './components/GoodsList';
export default {
  components: {
    AntPay,
    shopList,
    // goodsList,
  },
  data(){
    return {
      // goodsData: this.session('goodsData'),
      goodsData: {},
      purchaseGoods: false, // 是否购买过该商品
      previewOrderData: {},

      show: false, // 支付框
      paynum: '￥0.00', // 需支付的金额
      payData: {}, // 支付接口所用到的请求参数
    }
  },
  created(){
    this.getShopHome()

    if(this.$route.query.courseType === null){ // 专栏
      this.getColumnDetail()
    }else if( this.$route.query.courseType === 'VIDEO' || this.$route.query.courseType === 'AUDIO' ){ // 课程
      this.getCourseDetail()
    }else if(this.$route.query.courseType==='LIVE_VOICE' || this.$route.query.courseType==='LIVE_IMAGE_TEXT'
      || this.$route.query.courseType==='LIVE_EDUCATION' || this.$route.query.courseType==='LIVE_INTERACTIVE_VIDEO'){ // 直播
      this.getDirectDetail()
    }

  },
  methods: {
    onClickLeft(){
      this.$router.go(-1)
    },

    //获取店铺信息
    getShopHome() {
      introduce({shopId: this.$route.query.shopId}).then(res=>{
        this.shopDetail = res.data;
        this.$store.dispatch('mall/changeShopDetail', res.data)
      })
    },
    getColumnDetail() { // 专栏详情
      let req = { goodsId: this.$route.query.goodsId, shopId: this.$route.query.shopId };
      this.$route.query.inviteUserId && (req.inviteUserId = this.$route.query.inviteUserId);
      columnDetail(req).then(res=>{
        this.goodsData = res.data;
        this.goodsData.courseType = null;
        this.getPreviewOrder() // 订单预览
      })
    },
    getCourseDetail() { // 课程详情(视频，音频)
      let req = { goodsId: this.$route.query.goodsId, shopId: this.$route.query.shopId };
      this.$route.query.inviteUserId && (req.inviteUserId = this.$route.query.inviteUserId);
      courseDetail(req).then(res=>{
        this.goodsData = res.data;
        this.goodsData.courseType = res.data.type;
        this.getPreviewOrder() // 订单预览
      })
    },
    getDirectDetail() { // 直播详情
      let req = { goodsId: this.$route.query.goodsId, shopId: this.$route.query.shopId };
      this.$route.query.inviteUserId && (req.inviteUserId = this.$route.query.inviteUserId);
      directDetail(req).then(res=>{
        this.goodsData = res.data;
        this.getPreviewOrder() // 订单预览
      })
    },

    //订单预览
    getPreviewOrder(){
      previewOrder({
        "buyCount": 1, // 购买数量
        "goodsId": this.$route.query.goodsId, // 商品id
        "goodsVersionNo": this.goodsData.goodsVersionNo, // 商品版本号
        "integralUsed": 0, // 金币抵扣数量
        "productId": this.goodsData.productId, // 货品id
        "shopId": this.$route.query.shopId // 店铺id
      }).then(res=>{
        this.previewOrderData = res.data;
        if(this.previewOrderData.shelvesStatus !== 'ON_SHELF'){
          // 商品非上架状态
          this.$toast({message: '商品下架，无法购买该商品',duration: 3000})
        }
        if(this.previewOrderData.shopOpenStatus !=='OPEN'){
          // 店铺未开店状态
          this.$toast({message: '店铺未开业，无法购买该商品',duration: 3000})
        }
      })
    },

    // 点击支付按钮
    buyOrder(){
      let req = {
        "buyCount": 1, // 购买数量
        "goodsId": this.goodsData.goodsId, // 商品id
        "goodsVersionNo": this.goodsData.goodsVersionNo, // 商品版本号
        "integralUsed": 0, // 金币抵扣数量
        "previewActualAmount": this.previewOrderData.actualAmount, // 预览订单中的‘应付金额’
        "previewDiscountAmount": this.previewOrderData.discountAmount, // 预览订单中的‘优惠金额（含金币抵扣支付金额）’
        "previewOrderAmount": this.previewOrderData.orderAmount, // 预览订单中的‘订单金额’
        "productId": this.goodsData.productId, // 货品id
        "shopId": this.goodsData.shopId // 店铺id
      };
      this.goodsData.inviteUserId && (req.inviteUserId=this.goodsData.inviteUserId);


      this.$toast.loading({
        mask: true,
        message: '请稍后...',
        duration: 15000
      });

      placeOrder(req).then(res=>{
        // console.log(res.data)
        this.$toast.clear()
        if(res.data.orderNo){
          this.session('placeOrder', res.data)
          if(res.data.newPreviewInfo.actualAmount===0){ // 金额为0时，直接购买,无需调用支付接口

            this.$router.push({name: 'PaymentResults'})
          }else { // 需支付金额

            this.paynum = '￥' + res.data.newPreviewInfo.actualAmount.toFixed(2)
            this.payData ={
              amount: res.data.newPreviewInfo.actualAmount, // 支付金额
              orderNo: res.data.orderNo, // 订单号
              orderType: 1, // 订单类型，0：直播点卡，1：商城购物 ,
              userOpenid: this.session('userOpenId'),
            };
            this.show = true
            // console.log('padData', this.payData)
          }
        }else {
          let errorList = res.data.newPreviewInfo.errorList || [];
          if(errorList[0]){
            let text = '';
            switch (errorList[0]){
              case 'SHOP_CLOSED':
                text = '店铺已停业'
                break;
              case 'AGENT_SHOP_CLOSED':
                text = '分销的店铺已停业'
                break;
              case 'OFF_SHELF':
                text = '商品已下架'
                break;
              case 'STOCKS_LACK':
                text = '商品库存不足'
                break;
              case 'GOODS_UPDATED':
                text = '商品信息已更新，请重新下单'
                break;
              case 'INTEGRAL_LACK':
                text = '您的金币不足，请充值后再尝试'
                break;
              case 'PRICE_UPDATED':
                text = '预览订单金额发生改变，请重新操作'
                break;
              case 'REPEAT_PURCHASE':
                text = '请勿重复购买此商品'
                break;
              default:
                text = '其他异常，请联系管理员'
              break;
            }
            this.$toast(text)
          }else {
            this.$toast(res.message)
          }
        }
      })

    },
    // 支付弹框相关
    onPayClose(){
      this.show = false
    },
    onPay(obj){
      console.log('关闭弹框后的obj:',obj);
      this.show = false;

      this.payData.payType = obj.payType;
      this.payData.userOpenid = this.session('userOpenId');

      if(obj.payType==='blcPay'){ // 余额支付
        this.payData.payPassword = obj.payPassword
        this.payData.walletType = 0; //钱包类型，0：个人钱包，1：店铺钱包
      }

      if(obj.payType==='blcPay'){ // 余额支付
        getPaySignInfo(this.payData).then(res=>{
          if(res.code===200){
            this.purchaseGoods = true; // 更改“立即支付”按钮状态
            this.$refs.antpay.$success('支付成功！')
            this.$router.push({name: 'PaymentResults'})
          }else {
            this.$refs.antpay.$close(res.message)
          }
        })
      }else if(obj.payType==='wxJSAPI'){ // 微信支付
        let wxPay = obj;
        wxPay.wxPayType = '知识商城购物';
        this.session('wxPay', wxPay)
        this.$router.push({name: 'wxPay'})

      }
    }
  }
}
</script>

<style lang="less" scoped>
.order-preview{
  .shop-header{
    display: flex;
    height: 60px;
    font-size: 14px;
    border-bottom: .5px solid #edecec;
    .shop-img{
      width: 60px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      .img{
        display: block;
        width: 36px;
        height: 36px;
        border-radius: 50%;
      }
    }
    .shop-name{
      flex: 1;
      display: inline-flex;
      align-items: center;
    }
  }
  .goods-con{
    font-size: 14px;
    .goods{
      display: flex;
      height: 88px;
      border-bottom: .5px solid #edecec;
      background-color: #edecec;
      .img-con{
        width: 94px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        .img{
          display: block;
          width: 70px;
          height: 50px;
        }
      }
      .title-con{
        flex: 1;
        overflow: hidden;
        padding: 12px 12px 0 0;
        .title{
          /*height: 38px;*/
          padding-bottom: 2px;
          margin-bottom: 4px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          .type{
            margin: 0 5px 0 0;
            font-size: 9px;
            border: .75px solid #1585f3;
            color: #1585f3;
            border-radius: 2px;
            padding: 1px 2.5px;
          }
        }
        .sub-text{
          font-size: 12px;
          color: #7d7e80;
          .num-con{
            padding-bottom: 4px;
          }
          .num{padding-right: 24px;}
        }
      }
    }
  }
  .buy-icon-con{
    font-size: 14px;
    display: flex;
    align-items: center;
    .icon{
      display: block;
      height: 44px;
      width: 34px;
      background: url("../../assets/mall/buy.png") no-repeat 50% 50%;
      background-size: 18px 18px;
    }
  }
  .pay-btn{
    position: fixed;
    z-index: 1099;
    bottom: 0;
    left: 0;
    right: 0;


    font-size: 16px;
    border-top: .5px solid #edecec;

    .btn-con{
      display: flex;
      height: 50px;
      justify-content: flex-end;
      .total{
        flex: 1;
        display: inline-flex;
        justify-content: flex-end;
        align-items: center;
        padding: 0 12px;
      }
      .btn{
        width: 120px;
        height: 100%;
        background-color: #f74646;
        color: #fff;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        &.gray-btn{
          background-color: #cdcdcd;
          color: #fff;
        }
      }
    }
  }
}
</style>